<div
  class="flex grid-cols-2 flex-col items-center gap-4 md:grid md:justify-between"
>
  <h2
    class="text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17"
  >
    Audit Log
  </h2>

  
</div>



<app-filters [filters]="filterStructure"></app-filters>

<!-- table skeleton loader -->
 @if (isFetchingAuditLogList$ | async) {
<div class="mt-[0.94rem]">
  <app-table-skeleton-loader></app-table-skeleton-loader>
</div>
}

<!-- Table -->
 @if (!(isFetchingAuditLogList$ | async)) {
<div
  *appHasPermission="'get_all_audit_log'"
  class="mt-[0.94rem] rounded-lg border border-solid border-mango-gray200 bg-white"
>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div
        class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="flex border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold text-gray-600"
              >
                S/N
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M7.99998 3.33301V12.6663M7.99998 12.6663L12.6666 7.99967M7.99998 12.6663L3.33331 7.99967"
                    stroke="#667085"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </th>
             
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Name
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Action
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Role
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Date
              </th>
            </tr>
          </thead>

          <tbody>
            @if ((AuditLogList$ | async)?.length > 0) {
              @for (
                log of AuditLogList$ | async;
                track log;
                let i = $index
              ) {
                <tr>
                  <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                    <p>{{ i + 1 }}</p>
                  </td>
                  <td
                    class="r border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      @if (log.admin) {
                      {{ log.admin.first_name | titlecase }}
                      {{ log.admin.middle_name | titlecase }}
                      {{ log.admin.last_name | uppercase }}
                    } @else if (log.client) {
                      {{ log.client.first_name | titlecase }}
                      {{ log.client.middle_name | titlecase }}
                      {{ log.client.last_name | uppercase }}
                    } @else {
                      -
                    }
                    </p>
                  </td>
                  <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm cursor-pointer">
                    <p class="whitespace-no-wrap text-gray-900">
                    {{ (log.action ) || '-'}}
                    </p>
                  </td>
                  <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ log.role }}
                    </p>
                  </td>
                  <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ log.created_at | date: 'full' }}
                    </p>
                  </td>
                 
                </tr> 
              }
            }
          </tbody>
        </table>

        <app-table-navigator
          *ngIf="totalCount$ | async as totalCount"
          [total]="totalCount"
          (onNavigation)="navigate($event)"
        ></app-table-navigator>
      </div>
    </div>
  </div>
</div>
}